import type { Photo } from "../types";

export function getRemovedPreviewUrls(previousPhotos: Photo[], nextPhotos: Photo[]): string[] {
  const nextUrls = new Set(nextPhotos.map(({ preview }) => preview).filter(Boolean));
  return [
    ...new Set(
      previousPhotos
        .map(({ preview }) => preview)
        .filter((preview) => preview && !nextUrls.has(preview)),
    ),
  ];
}

export function revokeRemovedPreviewUrls(previousPhotos: Photo[], nextPhotos: Photo[]): void {
  for (const preview of getRemovedPreviewUrls(previousPhotos, nextPhotos)) {
    URL.revokeObjectURL(preview);
  }
}
